/**
 * The one sentence every weekend-grace row says about the rule itself (#583/#584 S15a, unit 6).
 *
 * It has to be true with the streak switch (`streak_rollout`) in either state, because the same
 * build serves dev (on) and production (off), and neither screen reads the switch.
 *
 *   Off: the legacy `update_user_streak()` trigger is the writer, and it never reads the setting.
 *        That is why the sentence still says the new rules are being built, and why the row keeps
 *        its coming-soon chip.
 *   On:  `streakDayClose.service.js` copies the setting into the family's version-1 policy epoch at
 *        activation, which the clock holds back while a family is still setting up, so the
 *        onboarding answer is the one copied. A later change is a `policy_change` epoch from the
 *        household's next local day (`recordWeekendGraceOn`, decision d-20261001-14), and
 *        `streakReducer.js` reads each date under its own epoch, so counted days never move.
 *
 * No "verified": Settings must not say that word (F13, `pages/contentHonesty.test.jsx`). No
 * semicolon and no "they", which a parent can read as the children.
 *
 * `shared/deferred-delivery.json` row `f17-weekend-grace` records what is still deferred.
 */
export const WEEKEND_RULE_SENTENCE =
  'The new streak rules are still being built. When those rules are on, a change to this switch counts from tomorrow. Days already counted stay the same.';

/**
 * Shown when the server refuses a second, different weekend change on one day (409
 * `WEEKEND_RULE_PENDING`). Tomorrow's rule is already written and cannot be replaced, so "try again
 * in a moment" would be false.
 */
export const WEEKEND_CHANGE_PENDING =
  'Weekend grace already changed today. The new rule starts tomorrow, and you can change it again then.';

export const WEEKEND_RULE_PENDING = 'WEEKEND_RULE_PENDING';
